import type { CalendarEvent } from "@/shared/repositories/CalendarEventRepository";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

type CarryInfo = Pick<
	CalendarEvent,
	"IsCarriedOver" | "IsPulledAhead" | "PlanDate" | "PlanShift"
>;

export const CARRIED_OVER_LABEL = "Carried over";
export const PULLED_AHEAD_LABEL = "Pulled ahead";

export const CarriedOverIcon = KeyboardDoubleArrowRightIcon;
export const PulledAheadIcon = KeyboardDoubleArrowLeftIcon;

/** The system took this order off its planned shift: carried over because it
 *  did not run in time, or pulled ahead because the queue ran dry. The bar stays
 *  on its planned window either way. */
export const carryNote = (ev: CarryInfo): string | null => {
	if (!ev.IsCarriedOver) return null;
	const planned = [
		ev.PlanDate ? ev.PlanDate.slice(5, 10).replace("-", "/") : null,
		ev.PlanShift,
	]
		.filter(Boolean)
		.join(" ");
	const label = ev.IsPulledAhead ? PULLED_AHEAD_LABEL : CARRIED_OVER_LABEL;
	return planned ? `${label} — planned ${planned}` : label;
};

export const CarryIcon = ({
	event,
	size = 13,
}: {
	event: CarryInfo;
	size?: number;
}) => {
	if (!event.IsCarriedOver) return null;
	const Icon = event.IsPulledAhead ? PulledAheadIcon : CarriedOverIcon;
	return (
		<Icon sx={{ fontSize: size, verticalAlign: "text-bottom", mr: "2px" }} />
	);
};
